import { Backdrop } from '@mui/material';
import { FC, useEffect } from 'react';
import CustomizedSingleSelectDropdown from '../CreateForm/DropdownBase';
import ShowCodeBlock from '../codeBlack';
import { CodePopupSelect } from '../constant/constant';

import WordpressInstruction from '../constant/wordpressInstruction';

import AngularInstruction from '../constant/angularInstruction';
import AngularInstructionJs from '../constant/angularInstructionJs';
import HtmlInstruction from '../constant/htmlInstruction';
import ReactInstructionHtml from '../constant/reactInstructionHtml';
import ReactInstructionJs from '../constant/reactInstructionJs';

interface CodePopupProps {
  onCloseClick: () => void;
  codeSnippet: string;
  codeSnippet1: string;
  closeIcon: string;
  setInstruction: any;
  instruction: any
}

const CodePopup: FC<CodePopupProps> = ({ onCloseClick, codeSnippet, closeIcon, instruction, setInstruction, codeSnippet1 }) => {

  useEffect(() => {
    console.log("instruction", instruction)
  }, [instruction])
  return (
    <Backdrop
      open={true}
      className='backdrop-container'
    >
      <div className="copyPopup">
        <div className="copyPopupContainer">
          <div className="copyPopupContent">
            <div className='EmbedTitleShare'>
              Embed your Conversational Form
            </div>
            <CustomizedSingleSelectDropdown
              value={instruction}
              setValue={(option: any) => {
                const newValue = typeof option === 'string' ? option : option.value;
                setInstruction(newValue);
              }}
              dataProvider={CodePopupSelect}
            />
            <div className="closeImg">
              <img src={closeIcon} alt="close" onClick={onCloseClick} />
            </div>
            <div className="snippetInstruction">
              <ShowCodeBlock text={codeSnippet}
              />

              {instruction === "HTML" && (
                <HtmlInstruction />
              )}

              {instruction === "React" && (
                <ReactInstructionHtml />
              )}


              {instruction === "Angular" && (
                <AngularInstruction />
              )}
              {instruction === "WordPress" && (
                <WordpressInstruction />
              )}
              {codeSnippet1 !== "" &&
                <ShowCodeBlock text={codeSnippet1}
                />

              }
              {instruction === "React" && (
                <ReactInstructionJs />
              )}


              {instruction === "Angular" && (
                <AngularInstructionJs />
              )}
            </div>
          </div>
        </div >
      </div >
    </Backdrop >
  )
}

export default CodePopup